import { PhosphorGlobeButton } from "components/Atoms/PhosphorIconButton";
import { InputBase } from "components/Atoms/formInputs/InputBase";
import React from "react";

const JsonApiUrlInput = (props: { url: string }) => <div className="margin-bottom-mini">
  <InputBase
    value={props.url}
    onChange={() => undefined}
    rightComponent={{
      position: "right",
      type: "action",
      content: <PhosphorGlobeButton layout="none" onClick={() => { window.open(props.url, "_blank"); }} />,
    }}
  />
</div>;

export default JsonApiUrlInput;